import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent"]

import { onBeforeMount, ref, computed, toRefs } from 'vue';
import Chip from 'primevue/chip';
import CheckboxForm from '@/components/Forms/CheckboxForm';
import { PERMISSIONS } from '@/enum/permissions';
import { can } from '@/composables';
import { useDisciplineStore, useAuthStore } from '@/store';
import { DisciplineInterface } from '@/types';

interface Props {
  organizationId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Disciplines',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const permissionToUpdate = can([PERMISSIONS.ORGANIZATION_SYNC_DISCIPLINES]);

const props = __props;
const disciplineStore = useDisciplineStore();
const authStore = useAuthStore();
const { organizationId } = toRefs(props);

const dirty = ref(false);

// eslint-disable-next-line
// @ts-ignore
const activeDisciplines = computed<DisciplineInterface[]>(() =>
  disciplineStore.disciplines?.filter((discipline) => discipline.checked),
);

const onSave = async () => {
  const result = await disciplineStore.saveDisciplines(organizationId.value);

  result === 200
    ? disciplineStore.doToast('Disciplines have been saved', 'Saved')
    : disciplineStore.doToast('There was an error saving. Please try again', 'Error', true);
};

const onUpdate = (id: string, checked: boolean) => {
  if (!dirty.value) {
    dirty.value = true;
  }
  disciplineStore.updateDiscipline({ id, checked });
};

const onCancel = () => {
  dirty.value = false;
  disciplineStore.getDisciplines(organizationId.value);
};

const icons: Record<string, string> = {
  'Behavioral Intervention': 'emoji_objects',
  'Occupational Therapy': 'work',
  'Physical Therapy': 'emoji_people',
  'Social Work/Counseling': 'handshake',
  Psychology: 'psychology',
  'Speech And Language': 'record_voice_over',
  'Special Education Teachers': 'school',
  'Education Diagnosticians': 'assessment',
};

onBeforeMount(() => {
  if (can([PERMISSIONS.ORGANIZATION_DISCIPLINES_INDEX])) disciplineStore.getDisciplines(organizationId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Card = _resolveComponent("Card")!

  return (!_unref(authStore).currentInstanceIsMasterTenant && _unref(permissionToUpdate))
    ? (_openBlock(), _createBlock(_unref(CheckboxForm), {
        key: 0,
        title: "Disciplines",
        items: _unref(disciplineStore).disciplines,
        "update-item": onUpdate,
        save: onSave,
        loading: _unref(disciplineStore).loading && _unref(permissionToUpdate),
        cancel: onCancel,
        dirty: dirty.value && _unref(permissionToUpdate),
        "class-name": "checkbox-form"
      }, null, 8, ["items", "loading", "dirty"]))
    : (_openBlock(), _createBlock(_component_Card, {
        key: 1,
        class: "form-card p-fluid checkbox-form"
      }, {
        header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h2", null, "Disciplines", -1)
        ]))]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(disciplineStore).loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createVNode(_component_Skeleton, {
                      key: n,
                      width: "100%",
                      height: "24px"
                    })
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeDisciplines.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "mb-2"
              }, [
                _createVNode(_unref(Chip), { class: "pl-0 pr-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      name: icons[item.name] || 'category',
                      size: "text-base",
                      class: "ml-1 text-color-purple"
                    }, null, 8, ["name"]),
                    _createElementVNode("span", {
                      class: "p-chip-text ml-1 font-semibold",
                      textContent: _toDisplayString(item.name)
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }))
}
}

})